<template lang='pug'>
    v-dialog(
        v-model="dialog" 
        persistent max-width="450px"
    )
        template(v-slot:activator="{ on, attrs }")
            v-btn(
                color="primary" 
                class="elevation-0 text-capitalize"
                @click="dialog = true"
            )
                | Show Approver 

        v-card
            v-card-text.pa-8
                v-icon(
                    color="orange lighten-2" 
                    size="60"
                ) mark_email_unread
                div(class="headline font-weight-bold mt-2 black--text") List Approver 
                div(class="mb-3 subtitle-1") Silahkan periksa permit dari email approver berikut

                v-list(v-if="approver.length > 0")
                    template(v-for="(item, index) in approver")
                        v-list-item( :key="item.email" class="pl-0 mb-1" )
                            v-list-item-avatar
                                v-icon( color="blue darken-1" ) person_outline
                            v-list-item-content
                                v-list-item-title {{ item.name }}
                                v-list-item-subtitle {{ item.email }}

                        v-divider( :key="index" class="pt-1" style="margin-left: 55px;" )
                        v-list(v-if="item.pjs && item.pjs.length > 0")
                            template(v-for="(el, idx) in item.pjs")
                                v-list-item( :key="el.email" class="pl-0 mb-1" )
                                    v-list-item-avatar
                                        v-icon( color="orange darken-1" ) person_outline
                                    v-list-item-content
                                        v-list-item-title {{ el.name }}
                                        v-list-item-subtitle {{ el.email }}
                                v-divider(
                                    :key="idx"
                                    class="pt-1"
                                    style="margin-left: 55px;"
                                )
                        
                
                template(v-else)
                    div(class="subtitle-1 font-weight-bold text-center mt-5") Belum Ada Data

            v-card-actions(class="pa-6")
                v-spacer
                v-btn(
                    depressed 
                    class="pl-4 pr-4"
                    @click="dialog = false"
                ) Close
</template>

<script>
export default {
  name: 'ListApprocer',
  data: () => ({
    dialog: false
  }),
  props: {
    approver: Array
  },
};
</script>
